import script from "./ContractsListSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractsListSection.vue?vue&type=script&setup=true&lang=js"

import "./ContractsListSection.vue?vue&type=style&index=0&id=11386b1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11386b1c"]])

export default __exports__